import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {labels, currentResource} from '../../../../util/utils';
import {AccountType, StatementType} from '../../../../util/uiconstants';
import SelectDropdown from '../../SelectDropdown/SelectDropdown';
import AssertionSelect from '../../RiskFactors/RelateRiskToAccounts/Risks/Accounts/AssertionSelect';
import FormField from '../../BaseComponentWrappers/MotifFormField';
import ToggleSwitch from '../../BaseComponentWrappers/MotifToggleSwitch';

function EditAccountAssertionsModal(props) {
	const allowedAccountTypes = [AccountType.Significant, AccountType.InSignificant, AccountType.LimitedRisk];

	const {editAccount, callFrom, createNewAccount} = props;
	const [selectedDesignation, setSelectedDesignation] = useState({}),
		[selectedStatementType, setSelectedStatementType] = useState(
			callFrom
				? {
						value: AccountType.Significant,
						label: currentResource.AccountType[AccountType.Significant - 1].accounttypename
				  }
				: {}
		),
		[isStatementTypeDisabled, setIsStatementTypeDisabled] = useState(false),
		[isHasEstimatedDisabled, setIsHasEstimatedDisabled] = useState(false),
		[selectedAssertions, setSelectedAssertions] = useState([]),
		[assertionsOptions, setAssertionsOptions] = useState([]),
		[isAssertionsDisabled, setIsAssertionsDisabled] = useState(true),
		[accountHasEstimate, setAccountHasEstimate] = useState(editAccount?.hasEstimate),
		[lastSelection, setLastSelection] = useState({accountId: null, selectedStatementType: {}, selectedAssertions: []}),
		[isLoadingEstimate, setisLoadingEstimate] = useState(false),
		[isClearable, setIsClearable] = useState(false),
		[lastSignificantEstimateState, setLastSignificantEstimateState] = useState(editAccount?.hasEstimate);
	const loadStatementType = () => {
		return currentResource.statementTypes.map(({id, name}) => {
			return {
				value: id,
				label: name
			};
		});
	};
	const loadAccountDesignations = () => {
		return currentResource.AccountType.map(({id, accounttypename}) => {
			return {
				value: id,
				label: accounttypename
			};
		}).filter((x) => allowedAccountTypes.includes(x.value)); // filtering out the allowed Account Types.
	};
	const statementTypeOptions = loadStatementType();
	const designationOptions = loadAccountDesignations();

	useEffect(() => {
		if (editAccount) {
			if (editAccount.accountTypeId) {
				if (!callFrom) {
					changeDesignation({
						value: editAccount.accountTypeId,
						label: currentResource.AccountType[editAccount.accountTypeId - 1].accounttypename
					});
				} else {
					changeDesignation({
						value: AccountType.Significant,
						label: currentResource.AccountType[AccountType.Significant - 1].accounttypename
					});
				}
				if (
					editAccount.accountTypeId === AccountType.Significant ||
					editAccount.accountTypeId === AccountType.SignificantDisclosure
				) {
					setIsStatementTypeDisabled(true);
				}
				// disable  estimated if account type is insignificant
				setIsHasEstimatedDisabled(editAccount.accountTypeId === AccountType.InSignificant);
			} else {
				setSelectedDesignation({});
				if (createNewAccount) {
					setSelectedStatementType({
						value: StatementType.Both,
						label: 'Both'
					});
					setSelectedAssertions([]);
					formatAssertionsOptions([], statementTypeOptions.find((sto) => sto.value === StatementType.Both).value);
				} else {
					if (editAccount && !editAccount?.statementTypeId) {
						setSelectedStatementType({
							value: StatementType.Both,
							label: 'Both'
						});
					}
					setSelectedAssertions([]);
					setAssertionsOptions([]);
				}
				setIsStatementTypeDisabled(true);
			}
			if (lastSelection.accountId !== editAccount.id) {
				setLastSelection({accountId: null, selectedStatementType: {}, selectedAssertions: []});
			}
			if (editAccount.statementTypeId && editAccount.statementTypeId > 0) {
				changeStatemenType({
					value: editAccount.statementTypeId,
					label: currentResource.statementTypes[editAccount.statementTypeId - 1].name
				});
				if (editAccount.assertions?.length > 0) {
					let formatAssertions = formatEditAccountAssertions();
					setSelectedAssertions(formatAssertions);
					setLastSelection({
						accountId: editAccount.id,
						selectedStatementType: {
							value: editAccount.statementTypeId,
							label: currentResource.statementTypes[editAccount.statementTypeId - 1].name
						},
						selectedAssertions: formatAssertions
					});
					formatAssertionsOptions(formatAssertions, editAccount.statementTypeId);
					setIsAssertionsDisabled(false);
				} else {
					formatAssertionsOptions([], editAccount.statementTypeId);
				}
			} else {
				if (createNewAccount) {
					setSelectedStatementType({
						value: StatementType.Both,
						label: 'Both'
					});
					setSelectedAssertions([]);
					formatAssertionsOptions([], statementTypeOptions.find((sto) => sto.value === StatementType.Both).value);
				} else {
					if (editAccount && !editAccount?.statementTypeId) {
						setSelectedStatementType({
							value: StatementType.Both,
							label: 'Both'
						});
					}
				}
			}
			if (accountHasEstimate !== editAccount.hasEstimate) {
				setisLoadingEstimate(true);
				setAccountHasEstimate(editAccount.hasEstimate);
			}
			if (!(editAccount.accountTypeId !== AccountType.Significant) || callFrom) {
				setIsAssertionsDisabled(false);
			} else {
				setIsAssertionsDisabled(true);
			}
		} else {
			setSelectedDesignation({});
			setSelectedStatementType({});
			setSelectedAssertions([]);
			setAssertionsOptions([]);
			setLastSelection({accountId: null, selectedStatementType: {}, selectedAssertions: []});
			setIsAssertionsDisabled(true);
			setisLoadingEstimate(false);
			setAccountHasEstimate(false);

			setIsHasEstimatedDisabled(selectedDesignation === AccountType.InSignificant);
			setIsStatementTypeDisabled(
				selectedDesignation === AccountType.Significant || selectedDesignation === AccountType.SignificantDisclosure
			);
			changeStatemenType(statementTypeOptions.find((sto) => sto.value === StatementType.Both));
			setSelectedStatementType(statementTypeOptions.find((sto) => sto.value === StatementType.Both));
		}
	}, [editAccount]);

	useEffect(() => {
		setisLoadingEstimate(false);
	}, [accountHasEstimate]);

	const handlerOnSelectDesignationChange = (selectedItem) => {
		if (selectedDesignation.value === AccountType.Significant) {
			setLastSignificantEstimateState(accountHasEstimate);
		}

		// AccountType.Significant should be changed with AccountType.SignificantDisclosure.
		// changeDesignation should set and return the selected assertions so added this before it.
		if (selectedItem.value === AccountType.SignificantDisclosure) {
			// disable statement type if Significant Disclosure is selected.
			setIsStatementTypeDisabled(true);
			changeStatemenType(statementTypeOptions.find((sto) => sto.value === StatementType.Both));
			setAccountHasEstimate(lastSignificantEstimateState);

			setIsAssertionsDisabled(false);
			setAssertionsOptions(
				assertionsOptions.map((item) => {
					return {
						...item,
						isSelected: item.assertionAbbreviation === 'P&D' ? true : false
					};
				})
			);
			setSelectedAssertions(assertionsOptions.filter((f) => f.assertionAbbreviation === 'P&D'));
		}

		let [statementType, assertions] = changeDesignation(selectedItem);
		formatAssertionsOptions(assertions, statementType?.value);
		if (props.handlerOnSelectDesignationChange) {
			props.handlerOnSelectDesignationChange({
				accountTypeId: selectedItem.value,
				statementTypeId:
					selectedItem.value === AccountType.InSignificant
						? AccountType.InSignificant
						: selectedStatementType
						? selectedStatementType.value
						: selectedStatementType,
				assertions: formatSelectedAssertions(assertions),
				hasEstimate: selectedItem.value === AccountType.Significant ? lastSignificantEstimateState : false
			});
		}
		if (selectedItem.value !== AccountType.Significant) {
			setAccountHasEstimate(false);
			setIsAssertionsDisabled(true);

			setIsStatementTypeDisabled(false);
		}

		if (selectedItem.value === AccountType.Significant) {
			setIsStatementTypeDisabled(editAccount && Object.keys(editAccount).length === 0);
			changeStatemenType(statementTypeOptions.find((sto) => sto.value === StatementType.Both));
			setAccountHasEstimate(lastSignificantEstimateState);

			if (statementType) {
				setIsAssertionsDisabled(false);
			}
		}

		if (selectedItem.value === AccountType.InSignificant || selectedItem.value === AccountType.LimitedRisk) {
			setIsStatementTypeDisabled(false);
			setIsAssertionsDisabled(true);
			setIsHasEstimatedDisabled(selectedItem.value === AccountType.InSignificant);
			setIsClearable(selectedItem.value === AccountType.InSignificant);
		} else {
			setIsHasEstimatedDisabled(false);
			setIsClearable(false);
		}
	};

	const changeDesignation = (selectedItem) => {
		let assertions = [];
		let options = [];
		let statementTypeFindId = selectedStatementType ? selectedStatementType.value : editAccount.statementTypeId;
		let statementType = statementTypeOptions?.find(
			(statementTypeOption) => statementTypeOption.value === statementTypeFindId
		);

		setIsStatementTypeDisabled(false);
		if (lastSelection.accountId === editAccount?.id && lastSelection.selectedStatementType) {
			setSelectedStatementType(lastSelection.selectedStatementType);
			statementType = lastSelection.selectedStatementType;
		}
		if (
			lastSelection.accountId === editAccount?.id &&
			lastSelection.selectedAssertions.length > 0 &&
			selectedItem.value === AccountType.Significant
		) {
			setIsAssertionsDisabled(false);
			setSelectedAssertions(lastSelection.selectedAssertions);
			assertions = lastSelection.selectedAssertions;
		}
		// AccountType.Significant should be changed with AccountType.SignificantDisclosure.
		if (selectedItem.value === AccountType.SignificantDisclosure) {
			assertions = assertionsOptions.filter((f) => f.assertionAbbreviation === 'P&D');
		}

		setSelectedAssertions(assertions);
		setSelectedStatementType(statementType);
		setSelectedDesignation(selectedItem);
		setAssertionsOptions(options);
		return [statementType, assertions];
	};

	const formatEditAccountAssertions = () => {
		const assertions = editAccount.assertions
			?.map((item) => {
				let selectedItem = currentResource.assertions.find((x) => x.value === item.id);
				let assertion = currentResource.assertions.find((x) => x.id === item.knowledgeAssertionId);
				return {
					id: item.id,
					value: assertion?.id,
					label: assertion?.assertionname,
					title: assertion?.assertionname,
					assertionAbbreviation: assertion?.assertionabbreviation,
					isSelected: selectedItem ? true : false
				};
			})
			.sort((a, b) => {
				return a.value - b.value;
			});

		return assertions;
	};

	const formatSelectedAssertions = (assertionlist) => {
		return assertionlist.map((item) => {
			return {
				assertionName: item.label,
				assertionAbbreviation: item.assertionAbbreviation,
				knowledgeAssertionId: item.value,
				displayOrder: item.value
			};
		}, this);
	};

	const handlerOnSelectedStatementTypeChange = (selectedItem) => {
		let assertions = [];
		let options = [];
		changeStatemenType(selectedItem);
		if (selectedDesignation.value === 1) {
			setLastSelection({
				accountId: editAccount.id,
				selectedStatementType: selectedItem,
				selectedAssertions: assertions
			});
		}
		setSelectedAssertions(assertions);
		setAssertionsOptions(options);
		if (props.handlerOnSelectedStatementTypeChange) {
			props.handlerOnSelectedStatementTypeChange({
				statementTypeId: selectedItem ? selectedItem.value : null,
				assertions: []
			});
		}
		if (selectedItem) {
			formatAssertionsOptions(assertions, selectedItem.value);
		}
	};

	const handlerOnHasEstimateChange = (event) => {
		setAccountHasEstimate(event.target.checked);
		if (props.handlerOnHasEstimateChange) {
			props.handlerOnHasEstimateChange({hasEstimate: event.target.checked});
		}
	};

	const changeStatemenType = (selectedItem) => {
		if (selectedDesignation.value === AccountType.Significant) {
			setIsAssertionsDisabled(false);
		}
		setSelectedStatementType(selectedItem);
	};

	const formatAssertionsOptions = (assertionsList, statementtypeid) => {
		let formattedAssertionList;
		if (assertionsList.length > 0) {
			formattedAssertionList = currentResource.assertions
				.filter(function(assertion) {
					return assertion.statementtypeid === statementtypeid;
				})
				.map((item) => {
					let selectedItem = assertionsList.find((x) => x.value === item.id);
					return {
						id: selectedItem ? selectedItem.id : item.id,
						value: item.id,
						label: item.assertionname,
						title: item.assertionname,
						assertionAbbreviation: item.assertionabbreviation,
						isSelected: selectedItem ? true : false
					};
				})
				.sort((a, b) => {
					return a.value - b.value;
				});
		} else {
			formattedAssertionList = currentResource.assertions
				.filter(function(assertion) {
					return assertion.statementtypeid === statementtypeid;
				})
				.map((item) => {
					return {
						id: item.id,
						value: item.id,
						label: item.assertionname,
						title: item.assertionname,
						assertionAbbreviation: item.assertionabbreviation,
						isSelected: false
					};
				})
				.sort((a, b) => {
					return a.value - b.value;
				});
		}
		setAssertionsOptions(formattedAssertionList);
	};

	const onOptionCheckedHandler = (isSelected, id) => {
		let updSelectedAssertions;
		if (isSelected) {
			updSelectedAssertions = updatedSelectedAssertions(id, isSelected);
		} else {
			updSelectedAssertions = removeFromSelectedAssertions(id);
		}
		setLastSelection({
			accountId: editAccount.id,
			selectedStatementType: selectedStatementType,
			selectedAssertions: updSelectedAssertions
		});
		if (props.handlerOnSelectedAssertionsChange) {
			props.handlerOnSelectedAssertionsChange({assertions: formatSelectedAssertions(updSelectedAssertions)});
		}
	};

	const updatedSelectedAssertions = (assertionId, isSelected) => {
		/**
		 * First, we spread the updated assertion in a new object
		 */
		const assertion = {...assertionsOptions.find((x) => x.id === assertionId)};
		assertion.isSelected = isSelected;
		/**
		 * Then, we make a new array with the updated assertion values and sort it by display order
		 */
		const updatedSelectedAssertions = [...selectedAssertions, assertion].sort((a, b) => {
			return a.value - b.value;
		});
		/**
		 * Also, we make a new copy of the available options and its updated values
		 */
		const updatedAssertionOptions = [...assertionsOptions];
		updatedAssertionOptions[updatedAssertionOptions.findIndex((x) => x.id === assertionId)].isSelected = true;
		/**
		 * Finally... we commit the changes to the state.
		 */
		setAssertionsOptions(updatedAssertionOptions);
		setSelectedAssertions(updatedSelectedAssertions);
		return updatedSelectedAssertions;
	};

	const removeFromSelectedAssertions = (assertionId) => {
		const newSelectedAssertions = selectedAssertions.filter((x) => x.id !== assertionId);
		const newSelectedAssertionOptions = [...assertionsOptions];
		newSelectedAssertionOptions[newSelectedAssertionOptions.findIndex((x) => x.id === assertionId)].isSelected = false;
		setSelectedAssertions(newSelectedAssertions);
		setAssertionsOptions(newSelectedAssertionOptions);
		return newSelectedAssertions;
	};

	// check if estimation should enable-if account type is insignificant then disable
	const hasEstimateEnabled =
		selectedDesignation &&
		Object.keys(selectedDesignation).length > 0 &&
		selectedDesignation.value === AccountType.InSignificant;

	return (
		<StyledEditAccountAssertionsModal className="StyledEditAccountAssertionsModal">
			<SelectDropdown
				key={'SelectDesignationDropdownKey'}
				id={'SelectDesignationDropdownId'}
				className={'accountdesignation-dropdown'}
				name={'SelectDesignationDropdown'}
				value={selectedDesignation}
				formLabel={labels.accountDesignationLabel}
				options={designationOptions}
				onChange={handlerOnSelectDesignationChange}
				hideSelectedOptions={false}
				isDisabled={editAccount && Object.keys(editAccount).length === 0 && !createNewAccount}
			/>
			<section className="SecondRowDropdowns">
				<SelectDropdown
					key={'SelectTypeDropdownKey'}
					id={'SelectTypeDropdownId'}
					className={'statementtype-dropdown'}
					name={'SelectTypeDropdown'}
					value={selectedStatementType}
					formLabel={labels.accountStatementTypeLabel}
					options={statementTypeOptions}
					isDisabled={true}
					onChange={handlerOnSelectedStatementTypeChange}
					hideSelectedOptions={false}
					isClearable={isClearable}
				/>
				<AssertionSelect
					value={selectedAssertions}
					options={assertionsOptions}
					onOptionChecked={onOptionCheckedHandler}
					isDisabled={isAssertionsDisabled}
				/>
			</section>
			<section className="accimpacted-toggle">
				{!isLoadingEstimate && (
					<FormField
						children={
							<>
								<span className="accimpacted-title">{labels.accountHasEstimateLabel}</span>
								{!props.isAresView && (
									<span className={!accountHasEstimate && !hasEstimateEnabled ? 'toggle-label active' : 'toggle-label'}>
										{labels.no}
									</span>
								)}
								<ToggleSwitch
									disabled={hasEstimateEnabled || isHasEstimatedDisabled}
									checked={accountHasEstimate}
									hideLabels
									onChange={handlerOnHasEstimateChange}
									id="toggleSwitchId"
								/>
								{props.isAresView ? (
									<span className="toggle-label">
										{accountHasEstimate && !hasEstimateEnabled ? labels.yes : labels.no}
									</span>
								) : (
									<span className={accountHasEstimate && !hasEstimateEnabled ? 'toggle-label active' : 'toggle-label'}>
										{labels.yes}
									</span>
								)}
							</>
						}
					/>
				)}
			</section>
		</StyledEditAccountAssertionsModal>
	);
}

export default EditAccountAssertionsModal;

const StyledEditAccountAssertionsModal = styled.section`
	margin: var(--px-30) var(--px-20) 0 0;
	border-bottom: var(--px-1) solid var(--neutrals-300);
	.accountdesignation-dropdown {
		width: 30%;
		display: block;
		margin-bottom: var(--px-36);
		&.select-disabled {
			cursor: default;
		}
		&.select-error {
			.show {
				position: absolute;
			}
		}
		.react-select-container {
			.react-select__control {
				.react-select__single-value {
					padding-top: var(--px-20) !important;
				}
				.react-select__value-container:not(.react-select__value-container--is-multi) > div .react-select__input {
					padding-top: var(--px-10) !important;
				}
			}
		}
	}
	.SecondRowDropdowns {
		display: flex;
		position: relative;
		margin-bottom: var(--px-30);
	}
	.statementtype-dropdown {
		width: 30%;
		margin-right: var(--px-40);
		height: var(--px-50);
		&.select-disabled {
			cursor: default;
		}
		&.select-error {
			.show {
				position: absolute;
			}
		}
		.react-select-container {
			height: var(--px-50);
			.react-select__control {
				height: var(--px-50);
				.react-select__single-value {
					padding-top: var(--px-20) !important;
				}
				.react-select__value-container:not(.react-select__value-container--is-multi) > div .react-select__input {
					padding-top: var(--px-10) !important;
				}
			}
		}
	}
	.assertions-wrapper {
		display: inline-flex;
		width: 30%;
		height: var(--px-50);
		.assertions-dropdown {
			width: 100%;
			height: var(--px-50);
			&.select-disabled {
				cursor: default;
			}
			.react-select-container {
				height: var(--px-50);
				.react-select__control {
					height: var(--px-50);
					.react-select__value-container--is-multi {
						height: auto !important;
					}
				}
			}
		}
		.assertions-dropdown
			.react-select-container
			.react-select__multi-value
			.react-select__multi-value__label:first-child {
			padding-bottom: var(--px-3);
		}
		.assertions-dropdown .react-select-container .react-select__multi-value {
			margin-top: var(--px-2);
		}
	}
	.accimpacted-toggle {
		margin-bottom: var(--px-30);
		.motif-form-field {
			margin-bottom: 0;
		}
		.accimpacted-title {
			display: block;
		}
		.toggle-label {
			&.active {
				font-weight: bold;
			}
		}
		.motif-toggle-switch-wrapper {
			display: inline-block;
			vertical-align: top;
			margin: var(--px-2) var(--px-3) 0 var(--px-3);
		}
	}
`;
